<template>
  <component :is="iconComponent" />
</template>

<script>
import IconSearch24px from "@/common/components/icons/IconSearch24px.vue";
import IconSearch28px from "@/common/components/icons/IconSearch28px.vue";

export default {
  components: {
    IconSearch24px,
    IconSearch28px
  },

  props: {
    iconSize: {
      type: [Number, String],
      default: 24
    }
  },

  computed: {
    iconComponent() {
      const { iconSize } = this;
      return `icon-search${iconSize}px`;
    }
  }
};
</script>
